export default {
    path: '',
    component: () => import(`@/page/distributor/component/basic-layout/1.0.4/index.vue`),
    children: [
        {
            path: '/distributor/credit/back',
            component: () => import('@/page/distributor/component/admin-layout/index.vue'),
            children: [
                {
                    path: '/distributor/account/deposit',
                    name: 'distributor-account-deposit',
                    component: () => import('./index.vue'),
                    meta: {
                        nav_list_for_admin_layout_head_nav: [
                            { name: `胤钱宝` },
                            { name: `预存款充值` },
                        ],
                    },
                },
            ]
        },
    ]
};
